import { Link } from 'react-router-dom';
import { sampleProductsPath } from '../lib/paths';
import { useCart } from './CartDrawer';
import FallbackImage from './FallbackImage';
import PriceDisplay from './PriceDisplay';

export default function ProductCard({ product }) {
  const { addItem } = useCart();

  return (
    <article className="product-card">
      <Link className="product-card-media" to={sampleProductsPath(`/products/${product.slug}`)}>
        <FallbackImage src={product.imageUrl} alt={product.name} />
        <span className="product-card-category">{product.category}</span>
        {product.discount > 0 ? <span className="product-card-sale">{product.discount}% OFF</span> : null}
      </Link>

      <div className="product-body">
        <p className="product-card-brand">{product.brand}</p>
        <h2 className="product-title">
          <Link to={sampleProductsPath(`/products/${product.slug}`)}>{product.name}</Link>
        </h2>
        <p className="muted clamp">{product.majorUsp}</p>
        <div className="badge-row product-card-tags">
          {product.conditions.slice(0, 3).map((condition) => (
            <span className="badge" key={condition}>
              {condition}
            </span>
          ))}
        </div>
        <PriceDisplay mrp={product.mrp} price={product.price} discount={product.discount} />
        <div className="actions">
          <Link className="btn secondary" to={sampleProductsPath(`/products/${product.slug}`)}>
            Details
          </Link>
          <button className="btn" type="button" onClick={() => addItem(product)}>
            Add
          </button>
        </div>
      </div>
    </article>
  );
}
